import { InjectionToken } from '@angular/core';

export type CashRegisterCurrency = 'EUR';

export interface PosModuleParams {
  currency?: CashRegisterCurrency;
  refundCreditId?: number;
  refundCashId?: number;
  hasTerminal?: boolean;
  companyId?: number;
  demoPayment?: boolean;
  /** Modal shown before finalize when the cart has a documentDeliveryMail:
      'choice' (default) = print only / mail only / both, 'additional-print' = mail is
      always sent, only asks whether to print in addition. */
  documentDeliveryPrompt?: DocumentDeliveryPromptMode;
}

export type DocumentDeliveryPromptMode = 'choice' | 'additional-print';

export const SOFTLINE_CONFIG_WWS_CASH_REGISTER_PARAMS =
  new InjectionToken<PosModuleParams>('SOFTLINE_CONFIG_WWS_CASH_REGISTER_PARAMS');

export const SOFTLINE_CONFIG_WWS_CASH_REGISTER_CURRENCY =
  new InjectionToken<CashRegisterCurrency>('SOFTLINE_CONFIG_WWS_CASH_REGISTER_CURRENCY');
